import { getSessionId, getPasskeyRegistrationStartTime, getAuthXToken } from '@/services/auth'
import { NR_PASSKEY_REGISTRATION_STEP, NR_PASSKEY_REGISTRATION_COMPLETE, EMAIL_DOMAIN_SITEMINDER } from './constants'

/**
 * Tracks passkey registration completion in New Relic.
 * Records the completion event and calculates duration from passkey registration start.
 */
export const nrPasskeyRegistrationComplete = (): boolean => {
  try {

    const authxToken = getAuthXToken()

    if (authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const sessionStartTime = getPasskeyRegistrationStartTime()

    const newrelic: any = (window as any).newrelic

    // Guard against invalid session start time
    if (!sessionStartTime || isNaN(Number(sessionStartTime))) {
      return false
    }

    const duration = Date.now() - Number(sessionStartTime)

    if (newrelic && sessionId) {
      newrelic.addPageAction(NR_PASSKEY_REGISTRATION_STEP, { sessionId, success: true })
      newrelic.addPageAction(NR_PASSKEY_REGISTRATION_COMPLETE, { sessionId, durationMs: duration })
      return true
    }

    return false
  } catch {
    return false
  }
}
